@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.transfer_intrabank.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mobile_wallet.feature.transfer_intrabank.generated.resources/"

internal val Res.string.feature_transfer_to_account: StringResource by lazy {
      StringResource("string:feature_transfer_to_account", "feature_transfer_to_account", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7169, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6613, 39),
      ))
    }

internal val Res.string.feature_transfer_transaction_id: StringResource by lazy {
      StringResource("string:feature_transfer_transaction_id", "feature_transfer_transaction_id", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7213, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6653, 59),
      ))
    }

internal val Res.string.feature_transfer_transfer_completed: StringResource by lazy {
      StringResource("string:feature_transfer_transfer_completed", "feature_transfer_transfer_completed", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7277, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6713, 79),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_transfer_to_account", Res.string.feature_transfer_to_account)
  map.put("feature_transfer_transaction_id", Res.string.feature_transfer_transaction_id)
  map.put("feature_transfer_transfer_completed", Res.string.feature_transfer_transfer_completed)
}
